import { Entity } from "@/core/common/Entity";
import SaldoDevedor from "./SaldoDevedor";

type DebitosData = {
  periodoApuracao: string | null;
  dataVencimento: string | null;
  debitoDeclarado: number;
  saldoDevedor: SaldoDevedor;
  parcelamento: number;
};

export default class Debito extends Entity<DebitosData> {
  private constructor(params: DebitosData) {
    super(params);

    Object.freeze(this);
  }

  static create(params: DebitosData): Debito {
    return new Debito(params);
  }

  getProps(): DebitosData {
    return this.props;
  }
}
